import { groups, extent, ascending } from 'd3-array';
import { regressionLoess } from 'd3-regression';
import { partyKeys } from '$lib/constants/crosswalk';

const validPartyKeys = new Set(partyKeys);

// H/T Harry Stevens https://observablehq.com/@harrystevens/introducing-d3-regression
export const createTrendLineData = (data) => {
  const groupedByParty = groups(data, (d) => d.party);

  const output = {};

  for (const [party, rows] of groupedByParty) {
    if (!validPartyKeys.has(party)) continue;

    const sorted = rows.slice().sort((a, b) => ascending(a.date, b.date));
    // Sparse parties (few polls) need a wider LOESS window than dense ones,
    // or the fit degenerates — keep roughly a 10-point window either way.
    const bandwidth = Math.min(1, Math.max(0.05, 10 / sorted.length));

    output[party] = regressionLoess()
      .x((d: any) => d.date)
      .y((d: any) => d.value)
      .bandwidth(bandwidth)(sorted)
      .map((d) => [new Date(d[0]), d[1]]);
  }

  return output;
};

export const createGroupTrendData = (data) => {
  const groupedByParty = groups(data, (d) => d.party);

  const trends = {};

  for (const [party, rows] of groupedByParty) {
    if (!validPartyKeys.has(party)) continue;

    trends[party] = rows
      .slice()
      .sort((a, b) => ascending(a.date, b.date))
      .map((d) => [d.date, d.value]);
  }

  return { trends };
};

export const determineExtents = (trends) => {
  const extents = {};
  for (const party of Object.keys(trends)) {
    const data = trends[party];
    extents[party] = extent(data, (d) => d[0]);
  }
  return extents;
};
